import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {

  public spinnerVisible!: boolean;

  constructor() {
    this.spinnerVisible = false;
  }

  public setSpinnerVisibility(visible: boolean) {
    this.spinnerVisible = visible;
  }

}
